<template>
  <div style="height:100%; width:100%; text-align-last: center; text-align: center; background-color: rgba(74, 74, 74,
  0.9)">
     <CubeLoader />
     <p class="centered loadingText">{{textOptions[0]}}</p>
  </div>
</template>

<script>
import CubeLoader from '../../components/common/CubeLoader.vue'
export default {
  name: "LoadingOverlay",
  components:{
    CubeLoader
},
  props:{
      show: Boolean
  },
  
  data() {
    return {
      options: {
        zIndex: 200,
      },
      textOptions: [
          "Daten werden geladen",
          "Kategorien werden ausgewertet",
          "Bewertungen werden erstellt",
          "Dashboard wird vorbereitet"
        ]
    };
  },
  mounted(){
    window.setInterval(()=>{
      this.pollText();
    }, 3000);

  },
  methods: {
    pollText(){
      const first = this.textOptions.shift();
      this.textOptions = this.textOptions.concat(first);
    }
  }
};
</script>
<style>
.centered{
  position:fixed;
  height:100px;
  top: calc(30% + 200px);
  left: calc(50% - 250px);
  width:500px;
}
.loadingText{
  font-size: 1.25rem;
  color: black;
}
</style>